export const DEFAULT_CART_COMPLETED_MESSAGE =
  'This cart has already been checked out. Your purchase is complete.';

export type CartMutationFeedbackFields = {
  cartCompleted?: boolean;
  cartCompletedMessage?: string;
};

export function isCartCheckoutCompleted(
  cart: CartMutationFeedbackFields | null | undefined,
): boolean {
  return Boolean(cart?.cartCompleted);
}

export function getCartCompletedMessage(
  cart: CartMutationFeedbackFields | null | undefined,
): string | null {
  if (!isCartCheckoutCompleted(cart)) {
    return null;
  }

  return cart?.cartCompletedMessage?.trim() || DEFAULT_CART_COMPLETED_MESSAGE;
}

export function areCartControlsDisabled(
  cart: CartMutationFeedbackFields | null | undefined,
): boolean {
  return isCartCheckoutCompleted(cart);
}

export function notifyCartCompleted(
  cart: CartMutationFeedbackFields | null | undefined,
  onNotify: (message: string, severity: 'warning' | 'info') => void,
): boolean {
  const message = getCartCompletedMessage(cart);
  if (!message) {
    return false;
  }

  onNotify(message, 'info');
  return true;
}

export function notifyCartMutationFeedback(
  cart: CartMutationFeedbackFields | null | undefined,
  onNotify: (message: string, severity: 'warning' | 'info') => void,
): 'completed' | null {
  if (notifyCartCompleted(cart, onNotify)) {
    return 'completed';
  }

  return null;
}
